import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import I18n from 'lib/i18n/i18n';
import WorthyApi from 'lib/api/worthyApi';
import Validators from 'lib/validators';
import {dataAutomationAttr, isMobile} from 'helpers/ApplicationHelper';
import {session} from 'actions/session';
import {InputTel, InputNumber} from 'components/formElements';
import worthyApi from "lib/api/worthyApi";

class FreeText extends Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this._validate = this._validate.bind(this);
        this._validatePhone = this._validatePhone.bind(this);
        this._validateReport = this._validateReport.bind(this);
        this._validateCaratWeight = this._validateCaratWeight.bind(this);
        this._validateLastName = this._validateLastName.bind(this);
        this.onFocusPhone = this.onFocusPhone.bind(this);
        this.onFieldFocus = this.onFieldFocus.bind(this);
        // this.onFocusReport = this.onFocusReport.bind(this);
        this.onAfterChangePhone = this.onAfterChangePhone.bind(this);
        // this.onAfterChangeReport = this.onAfterChangeReport.bind(this);
    }

    componentDidMount() {
        this._inputFreeText = this.refs['inputFreeText'];
        this.props.freeTextField ? null : this._validate()
    }

    _validate() {
       this.props.message.input_type === 'number' ? this._validateInputFreeTextAsNumber() : this._validateInputFreeTextAsText()
    }

    _validateLastName(){
        let value = this._inputFreeText.value;
        let submitBtn = 'submit-address2';
        if(Validators.validateName(value) && Validators.validateNotEmpty(value)){
            document.getElementsByClassName(submitBtn)[0].classList.remove('disabled');
        }
        else{
            document.getElementsByClassName(submitBtn)[0].classList.add('disabled');
        }
    }

    _validatePhone() {
        let submitBtn = document.querySelector('.submit-phone');
        this.disableButton(submitBtn);
        this._inputFreeText.clearErrors();
        if (Validators.validatePhone(this._inputFreeText.state.value)) {
            this.onSubmit('changePhone');
        } else {
            this._inputFreeText.setError(I18n.getString('itemPage::highValueEstimation::1::errors::phone'));
            this.enableButton(submitBtn);
        }
    }

    _validateReport() {
        let value = this._inputFreeText.state.value;
        let submitBtn = document.querySelector('.submit-report');
        this.disableButton(submitBtn);
        this._inputFreeText.clearErrors();
        if (Validators.validateReport(this._inputFreeText.state.value)) {
            this.onSubmit('changeReport');
        } else {
            this._inputFreeText.setValue(value);
            this._inputFreeText.setError(I18n.getString('itemPage::highValueEstimation::1::errors::reportNumber'));
            this.enableButton(submitBtn);
        }
    }

    _validateCaratWeight() {
        let value = this._inputFreeText.state.value;
        let submitBtn = document.querySelector('.submit-carat');
        this.disableButton(submitBtn);
        this._inputFreeText.clearErrors();
        if (Validators.validateCarat(this._inputFreeText.state.value)) {
            this.onSubmit('changeCaratWeight');
        } else {
            this._inputFreeText.setValue(value);
            this._inputFreeText.setError(I18n.getString('itemPage::highValueEstimation::1::errors::caratWeight'));
            this.enableButton(submitBtn);
        }
    }

    _validateInputFreeTextAsNumber() {
        if (Validators.validateNumber(this._inputFreeText.value, 0) && Validators.validateNotEmpty(this._inputFreeText.value)) {
            document.getElementsByClassName('submit-address2')[0].classList.remove('disabled');
        } else {
            document.getElementsByClassName('submit-address2')[0].classList.add('disabled');
        }
    }

    _validateInputFreeTextAsText() {
        if (Validators.validateNotEmpty(this._inputFreeText.value)) {
            document.getElementsByClassName('submit-address2')[0].classList.remove('disabled');
        } else {
            document.getElementsByClassName('submit-address2')[0].classList.add('disabled');
        }
    }

    onSubmitPhone(buttonText) {
        this._validatePhone();
        this.props.saveLog(I18n.getString('itemPage::highValueEstimation::1::events::messages::button').replace('{buttonText}', buttonText));
    }

    onFocusPhone() {
        this.flag_revisedPhoneAfterFocus = false;
        this.phoneSaveLog('selected');
    }

    onAfterChangePhone() {
        !this.flag_revisedPhoneAfterFocus && (this.flag_revisedPhoneAfterFocus = true, this.phoneSaveLog('revised'));
    }

    phoneSaveLog(strAction) {
        this.props.saveLog(I18n.getString('itemPage::highValueEstimation::1::events::messages::phoneField').replace('{action}', strAction));
    }

    onSubmitReport(buttonText) {
        this._validateReport();
        this.props.saveLog(I18n.getString('itemPage::highValueEstimation::1::events::messages::button').replace('{buttonText}', buttonText));
    }

    onSubmitCaratWeight(buttonText) {
        this._validateCaratWeight();
        this.props.saveLog(I18n.getString('itemPage::highValueEstimation::1::events::messages::button').replace('{buttonText}', buttonText));
    }

    removeScrollFromInputNumber(){
        document.querySelector('input[type=number]').addEventListener('mousewheel', (event) => {event.target.blur()});
    }

    onFieldFocus(){
        this.removeScrollFromInputNumber();
        this._inputFreeText.clearErrors();
    }

    showBtnLoader(element) {
        element.classList.add('btn-loading');
        element.textContent = '';
    }

    enableButton(element) {
        element && element.classList.remove('disable-button');
    }

    disableButton(element){
        element && element.classList.add('disable-button');
    }

    onSubmit(toSubmit = '') {
        if(toSubmit === 'changePhone') {
            let submitBtn = document.querySelector('.submit-phone');
            let isBundle = this.props.chatBotType ===  "jewelryBox";
            this.showBtnLoader(submitBtn);
            WorthyApi.updateUserPhone(this.props.itemId, this.props.userId, this._inputFreeText.state.value, this.props.appointmentTime, isBundle)
            .then(() => {
                let ud = Object.assign({}, this.props.Session.userData._userData);
                ud.phone = this._inputFreeText.state.value;
                this.props.session(ud);
                this.props.onSubmit(this.props.message, this._inputFreeText.state.value);
            })
            .finally(() => {
                this.enableButton(submitBtn);
            });

        } else if (toSubmit === 'changeReport') {
            let submitBtn = document.querySelector('.submit-report');
            this.showBtnLoader(submitBtn);
            WorthyApi.updateCertificateNumber(this.props.itemId , this._inputFreeText.state.value)
                .then(() => {
                    this.props.onSubmit(this.props.message, this._inputFreeText.state.value);
                })
                .finally(() => {
                    this.enableButton(submitBtn);
                });

        } else if (toSubmit === 'changeCaratWeight') {
            let submitBtn = document.querySelector('.submit-carat');
            this.showBtnLoader(submitBtn);
            WorthyApi.updateCaratWeight(this.props.itemId , this._inputFreeText.state.value)
                .then(() => {
                    this.props.onSubmit(this.props.message, this._inputFreeText.state.value);
                })
                .finally(() => {
                    this.enableButton(submitBtn);
                });

        } else if(toSubmit === 'setLastName'){
            worthyApi.setLastName(this._inputFreeText.value)
                .then(() => {
                    this.props.onSubmit(this.props.message, this._inputFreeText.value);
                });
        }

        else {
            this.props.onSubmit(this.props.message, this._inputFreeText.value);
        }
    }

    render(){
        const buttonText = this.props.message.button_text || 'Send';
        switch (this.props.freeTextField) {
            case 'changePhone':
                return (<div id={this.props.id}
                             className='message-input-container message-free-text absolute-position input-root'>
                    <InputTel ref="inputFreeText"
                              name="phone"
                              inputId="phone-input"
                              defaultValue={this.props.userPhone ? this.props.userPhone : ''}
                              inputProps={{
                                  required: true,
                                  placeholder: 'Please enter your phone'
                              }}
                              validator={this._validatePhone}
                              onFocus={this.onFocusPhone}
                              onAfterChange={this.onAfterChangePhone}
                    />
                    <div className='submit-phone' onClick={this.onSubmitPhone.bind(this, buttonText)}>{buttonText}</div>
                </div>);
                break;
            case 'changeReport':
                return (<div id={this.props.id}
                             className='message-input-container message-free-text absolute-position input-root'>
                    <InputNumber ref="inputFreeText"
                                 name="report"
                                 inputId="report-input"
                                 inputProps={{required: true, placeholder: 'Enter report number'}}
                                 validator={this._validateReport}
                                 onFocus={this.onFieldFocus}
                        // onAfterChange={this.onAfterChangeReport}
                    />
                    <div className='submit-report' onClick={this.onSubmitReport.bind(this, buttonText)}>{buttonText}</div>
                </div>);
                break;
            case 'changeCaratWeight':
                return (<div id={this.props.id}
                             className='message-input-container message-free-text absolute-position input-root'>
                    <InputNumber ref="inputFreeText"
                                 name="carat"
                                 inputId="carat-input"
                                 inputProps={{required: true, placeholder: 'Enter carat weight'}}
                                 validator={this._validateCaratWeight}
                                 onFocus={this.onFieldFocus}
                        // onAfterChange={this.onAfterChangeReport}
                    />
                    <div className='submit-carat' onClick={this.onSubmitCaratWeight.bind(this, buttonText)}>{buttonText}</div>
                </div>);
                break;

            case 'setLastName':
                return (<div id={this.props.id}
                             className='message-input-container message-free-text absolute-position input-root'>
                    <input
                        ref="inputFreeText"
                        type={'text'}
                        name="free-text"
                        placeholder={this.props.message.text}
                        onBlur={this.props.onBlur}
                        data-automation={dataAutomationAttr(this.props.message.text)}
                        onChange={this._validateLastName}
                        maxLength={50}
                    />
                    <div className='submit-address2 disabled' onClick={() => this.onSubmit("setLastName")}>{buttonText}</div>
                </div>);
                break;
            default:
                return (<div id={this.props.id}
                             className='message-input-container message-free-text absolute-position input-root'>
                    <input
                        ref="inputFreeText"
                        type={this.props.message.input_type === 'number' ? (isMobile() ? 'tel' : 'number') : 'text'}
                        name="free-text"
                        placeholder={this.props.message.text}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        data-automation={dataAutomationAttr(this.props.message.text)}
                        onChange={this._validate}
                    />
                    <div className='submit-address2' onClick={() => this.onSubmit(false)}>{buttonText}</div>
                </div>);
                break;
        }
    }
}

const mapStateToProps = ({Session}) => {
    return {Session}
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({session}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeText);